import { useLanguage } from "../i18n/LanguageContext";

export function LanguageToggle({ style }) {
  const { lang, setLang } = useLanguage();

  return (
    <div
      data-testid="language-toggle"
      style={{
        display: "flex", borderRadius: "6px", overflow: "hidden",
        border: "1px solid var(--primary-color)", ...style
      }}
    >
      <button
        onClick={() => setLang("es")}
        data-testid="lang-es-button"
        style={{
          padding: "4px 8px", border: "none", cursor: "pointer", fontSize: "11px", fontWeight: "bold",
          backgroundColor: lang === "es" ? "var(--primary-color)" : "var(--white)",
          color: lang === "es" ? "var(--white)" : "var(--primary-color)"
        }}
      >
        ES
      </button>
      <button
        onClick={() => setLang("en")}
        data-testid="lang-en-button"
        style={{
          padding: "4px 8px", border: "none", cursor: "pointer", fontSize: "11px", fontWeight: "bold",
          backgroundColor: lang === "en" ? "var(--primary-color)" : "var(--white)",
          color: lang === "en" ? "var(--white)" : "var(--primary-color)"
        }}
      >
        EN
      </button>
    </div>
  );
}
